import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import DetailRow from "../CustomComponents/DetailRow";
import UserAvatar from "../CustomComponents/UserAvatar";

const SendReferralAgreementModal = ({ handleEditModalClose, editData }) => {
  const [mounted, setMounted] = React.useState(false);

  console.log(editData);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <ModalContainer handleClose={handleEditModalClose}>
      <div
        className={cssStyles.modalContainer}
        style={
          {
            // maxWidth: "80%"
          }
        }
      >
        {/* Header */}
        <div className="d-flex align-items-center w-100 justify-content-between mb-4">
          <p className="fs-4 fw-medium m-0 ">Send</p>
          <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
            <FaCircleXmark
              role="button"
              onClick={handleEditModalClose}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>

        {/* Body */}
        <div className="w-100">
          <Row className="g-5">
            <DetailRow
              title="Wallet Amount"
              value={`$${editData?.wallet_amount}`}
            />
          </Row>
        </div>
      </div>
    </ModalContainer>
  );
};

export default SendReferralAgreementModal;
